import { NavItem } from '../types/navigation';

export const NAV_ITEMS: NavItem[] = [
  { key: 'nav.home', href: '#' },
  { key: 'nav.about', href: '#' },
  { key: 'nav.publications', href: '#' },
  { key: 'nav.resources', href: '#' },
  { key: 'nav.news', href: '#' },
  { key: 'nav.events', href: '#' },
  { key: 'nav.gallery', href: '#' },
  { key: 'nav.contact', href: '#' },
  { key: 'nav.faqs', href: '#' }
];